import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { LoadingState } from "@/components/ui/States";

const HomePage = lazy(() => import("@/pages/HomePage"));
const PackagesPage = lazy(() => import("@/pages/PackagesPage"));
const PackageDetailsPage = lazy(() => import("@/pages/PackageDetailsPage"));
const DestinationsPage = lazy(() => import("@/pages/DestinationsPage"));
const DestinationDetailsPage = lazy(() => import("@/pages/DestinationDetailsPage"));
const ServicesPage = lazy(() => import("@/pages/ServicesPage"));
const PlanYourTripPage = lazy(() => import("@/pages/PlanYourTripPage"));
const TrackInquiryPage = lazy(() => import("@/pages/TrackInquiryPage"));
const TravelGuidesPage = lazy(() => import("@/pages/TravelGuidesPage"));
const AboutPage = lazy(() => import("@/pages/AboutPage"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const PrivacyPage = lazy(() => import("@/pages/PrivacyPage"));
const TermsPage = lazy(() => import("@/pages/TermsPage"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));

export default function App() {
  return (
    <Suspense fallback={<div className="route-loader"><LoadingState /></div>}>
      <Routes>
        <Route element={<SiteLayout />}>
          <Route index element={<HomePage />} />
          <Route path="packages" element={<PackagesPage />} />
          <Route path="packages/:slug" element={<PackageDetailsPage />} />
          <Route path="destinations" element={<DestinationsPage />} />
          <Route path="destinations/:slug" element={<DestinationDetailsPage />} />
          <Route path="services" element={<ServicesPage />} />
          <Route path="plan-your-trip" element={<PlanYourTripPage />} />
          <Route path="track-inquiry" element={<TrackInquiryPage />} />
          <Route path="travel-guides" element={<TravelGuidesPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="terms" element={<TermsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

